var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_vm._v(" "),(_vm.loading)?_c('vue-snotify'):_vm._e(),_vm._v(" "),_c('notification-worker',{ref:"notificationWorker"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }